import { i18n } from '@debijenkorf/dbk-common';

import { type FormattedBreadcrumbs } from './formatBreadcrumbs';

export const getBackButton = (breadcrumbs: FormattedBreadcrumbs, originLister?: string) => {
  if (originLister)
    return {
      url: originLister,
      text: i18n.t('responsive-assets.pdp.navigation.back.lister'),
    };

  if (!breadcrumbs || breadcrumbs?.length < 2) return undefined;

  const { relativeUrl, text } = breadcrumbs[breadcrumbs.length - 2];

  return {
    text: i18n.t('responsive-assets.plp.breadcrumbs.backButton', {
      page: text.toLowerCase(),
      interpolation: { escapeValue: false },
    }),
    url: relativeUrl,
  };
};
